import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const StaffLogin = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        try {
            const res = await fetch('https://menu.searchisend.in/apimenu/v2/v2_staff_auth.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ username, password })
            });
            const json = await res.json();
            if (json.success) {
                localStorage.setItem('staff_token', json.token);
                localStorage.setItem('staff_user', JSON.stringify(json.staff));
                if (json.staff.role === 'delivery') {
                    navigate('/delivery-dashboard');
                } else if (json.staff.role === 'waiter') {
                    navigate('/waiter-dashboard');
                } else {
                    navigate('/kitchen-dashboard');
                }
            } else {
                if (json.chances_left !== undefined && json.chances_left > 0) {
                    setError(`${json.message} ${json.chances_left} attempts remaining.`);
                } else {
                    setError(json.message || 'Login failed.');
                }
            }
        } catch (err) {
            setError("Server error. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f8fafc', padding: '20px', fontFamily: "'Outfit', sans-serif" }}>
            <div style={{ background: '#fff', padding: '40px', borderRadius: '24px', boxShadow: '0 25px 50px -12px rgba(0,0,0,0.1)', maxWidth: '400px', width: '100%' }}>
                <div style={{ textAlign: 'center', marginBottom: '30px' }}>
                    <div style={{ width: '64px', height: '64px', background: 'var(--primary-orange)', color: '#fff', borderRadius: '20px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '2rem', margin: '0 auto 15px', boxShadow: '0 8px 16px rgba(234,88,12,0.2)' }}>
                        <i className="fas fa-fire-burner" />
                    </div>
                    <h1 style={{ margin: 0, fontSize: '1.5rem', fontWeight: '800' }}>Staff Access</h1>
                    <p style={{ color: '#64748b', margin: '5px 0 0 0' }}>Log in to view Kitchen / Waiter tasks</p>
                </div>

                <form onSubmit={handleLogin}>
                    <div style={{ marginBottom: '15px' }}>
                        <label style={{ display: 'block', marginBottom: '8px', fontSize: '0.9rem', fontWeight: '600', color: '#1e293b' }}>Staff Username</label>
                        <input 
                            type="text" 
                            placeholder="Enter your username"
                            value={username}
                            onChange={e => setUsername(e.target.value)}
                            style={{ width: '100%', padding: '14px', borderRadius: '12px', border: '1px solid #e2e8f0', boxSizing: 'border-box', outline: 'none', transition: '0.2s' }}
                            required
                        />
                    </div>
                    <div style={{ marginBottom: '25px' }}>
                        <label style={{ display: 'block', marginBottom: '8px', fontSize: '0.9rem', fontWeight: '600', color: '#1e293b' }}>Password</label>
                        <input 
                            type="password" 
                            placeholder="••••••••"
                            value={password}
                            onChange={e => setPassword(e.target.value)}
                            style={{ width: '100%', padding: '14px', borderRadius: '12px', border: '1px solid #e2e8f0', boxSizing: 'border-box', outline: 'none', transition: '0.2s' }}
                            required
                        />
                    </div>

                    {error && <p style={{ color: '#ef4444', fontSize: '0.9rem', textAlign: 'center', marginBottom: '20px', fontWeight: '600' }}>{error}</p>}

                    <button 
                        type="submit" 
                        disabled={loading}
                        style={{ width: '100%', padding: '14px', borderRadius: '50px', border: 'none', background: 'var(--primary-orange)', color: '#fff', fontWeight: '800', cursor: 'pointer', fontSize: '1rem', transition: '0.2s', boxShadow: '0 4px 12px rgba(234,88,12,0.3)' }}
                    >
                        {loading ? 'Authenticating...' : 'Secure Login'}
                    </button>
                </form>

                <p style={{ textAlign: 'center', color: '#94a3b8', fontSize: '0.85rem', marginTop: '25px' }}>
                    Need access? Ask your restaurant admin to create a staff account for you.
                </p>
            </div>
        </div>
    );
};

export default StaffLogin;

